import { FormattedMessage } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import Typography from '@alltrails/core/components/Typography';
import barlettImg from '../../assets/images/advisor/barlett.avif';
import styles from './styles/styles.module.scss';

// Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701%3A10862&t=GIO5RrtS36gjSh8J-4
// Mobile: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701%3A11369&t=GIO5RrtS36gjSh8J-4
export default function MedicalAdvisor() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div>
          <Image alt="" src={barlettImg} className={styles.img} loading="lazy" />
        </div>
        <div className={styles.right}>
          <Typography component="div" variant="heading600">
            <FormattedMessage defaultMessage="Meet our medical advisor" />
          </Typography>
          <Typography className={styles.bio} component="div" variant="paragraph200">
            <FormattedMessage defaultMessage="Suzanne Bartlett Hackenmiller is a physician, certified forest therapy guide, author of The Outdoor Adventurer’s Guide to Forest Bathing, and chief medical advisor for AllTrails. Dr. Hackenmiller is board certified in OB-Gyn, Integrative Medicine, and Lifestyle Medicine, and has certifications in herbal medicine, Ayurveda, and meditation. She has served as medical director of the Association of Nature and Forest Therapy and as lead physician for Chopra Whole Health Retreats. Currently, Dr. Hackenmiller practices at HonorHealth Integrative Medicine in Scottsdale, Arizona, United States." />
          </Typography>
          <Typography component="div" variant="heading300">
            <FormattedMessage defaultMessage="Dr. Bartlett Hackenmiller" />
            <br />
            <span className={styles.title}>
              <FormattedMessage defaultMessage="Chief Medical Advisor" />
            </span>
          </Typography>
        </div>
      </div>
    </div>
  );
}
